import request from '@/utils/request'
// 通知接口

export function getNotifyNum () {
    return request({
        url: 'notify/notRead',
        method: 'get'
    })
}

export function getNotifyList (query) {
    return request({
        url: 'notify',
        method: 'get',
        params: query
    })
}

export function getNotifyInfo (id, query) {
    return request({
        url: `notify/${id}`,
        method: 'get',
        params: query
    })
}
